import makeRequest from 'utils/makeRequest';

const fetchItemByMsid = (liveblogMsid, itemMsid) => {
  const url = `/feeds/react_get_liveblog_snippet_feed.cms?msid=${liveblogMsid}&snippetid=${itemMsid}&feedtype=sjson`;
  return makeRequest.get(url, {}, 'skipfeedengine');
};

export default fetchItemByMsid;
